module.exports = __webpack_public_path__ + "static/media/Host_Available_Property_Approved.3e7d8c89.png";